import {useEffect, useState} from 'react';

/**
 * A blob URL for the file that is revoked when the file changes or the caller unmounts, so previews never leak memory.
 */
export function useObjectUrl(file: File | null): string | null {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setObjectUrl(null);

      return undefined;
    }

    const createdUrl = URL.createObjectURL(file);
    setObjectUrl(createdUrl);

    return (): void => {
      URL.revokeObjectURL(createdUrl);
    };
  }, [file]);

  return objectUrl;
}
